import { Link } from 'react-router';

import { cn } from '@/lib/utils';
import { ProductPictogramMark } from '@/platform/lib/product-icon';
import type { PlatformProductTile } from '@/platform/lib/products';

export function ProductTile({
  tile,
  compact = false,
}: {
  tile: PlatformProductTile;
  compact?: boolean;
}) {
  const planned = tile.status === 'planned' || !tile.href;
  const pad = compact ? 'gap-1.5 p-3' : 'gap-2 p-5';
  const title = compact ? 'text-sm leading-snug font-semibold' : 'text-lg font-semibold';
  const body = compact ? 'text-xs leading-snug' : 'text-sm';
  const action = compact ? 'text-xs' : 'mt-auto pt-2 text-sm';
  const frame = cn('flex w-full min-w-0 flex-col rounded-lg border text-left', pad);

  const heading = (
    <div className="flex min-w-0 items-start gap-2">
      <ProductPictogramMark code={tile.code} size={compact ? 'sm' : 'md'} className="mt-0.5" />
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-x-2 gap-y-1">
        <h2
          className={cn(title, 'min-w-0 break-words', planned ? 'text-foreground' : 'text-primary')}
        >
          {tile.labelDe}
        </h2>
        {planned ? (
          <span className="shrink-0 rounded bg-secondary px-2 py-0.5 text-xs font-medium text-secondary-foreground">
            Demnächst
          </span>
        ) : null}
      </div>
    </div>
  );

  if (planned || !tile.href) {
    return (
      <div className={cn(frame, 'border-dashed border-border bg-muted/80')} aria-disabled="true">
        {heading}
        <p className={cn(body, 'text-muted-foreground')}>{tile.descriptionDe}</p>
      </div>
    );
  }

  const href = tile.href;

  return (
    <Link
      to={href}
      className={cn(
        frame,
        'border-border bg-background',
        compact ? 'hover:bg-muted' : 'bg-card shadow-sm hover:border-primary hover:bg-accent',
        'transition-colors focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none',
      )}
    >
      {heading}
      <p className={cn(body, 'text-muted-foreground')}>{tile.descriptionDe}</p>
      <span className={cn(action, 'font-medium text-primary')}>Öffnen →</span>
    </Link>
  );
}
